import Image from 'next/image';
import React from 'react';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { toast } from 'react-toastify';
import * as S from '@styles/common/form/formFileUpload.style';
import { IconCircleXFilled, IconPlus } from '@tabler/icons-react';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const AttachImageFormV2 = ({
  isEditMode,
  files,
  onAddFiles,
  onDeleteFiles
}) => {
  const IMAGE_ATTACH_LIMIT = 9;
  return /*#__PURE__*/_jsx(S.FileListWrapper, {
    boxStyles: {
      width: '100%',
      height: '100%',
      paddingTop: '100%'
    },
    wrapperStyles: {
      gridTemplateColumns: 'repeat(6, minmax(0, 1fr))',
      display: 'grid'
    },
    buttonStyles: {
      width: '100%',
      height: '100%'
    },
    children: isEditMode ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("input", {
        type: "file",
        id: "add-file",
        accept: ".svg, .jpg, .png, .jpeg",
        multiple: true,
        onChange: e => {
          if (e.target.files.length > 0) {
            if (files.length + e.target.files.length > IMAGE_ATTACH_LIMIT) {
              toast.info(`이미지는 ${IMAGE_ATTACH_LIMIT}장까지만 첨부할 수 있습니다.`);
              return;
            }
            onAddFiles([...e.target.files].map(file => ({
              url: URL.createObjectURL(file),
              isRemote: false
            })));
          }
        }
      }), /*#__PURE__*/_jsx("label", {
        className: 'add-file-box',
        htmlFor: "add-file",
        onClick: e => {
          if (files.length >= IMAGE_ATTACH_LIMIT) {
            e.preventDefault();
            toast.info(`이미지는 ${IMAGE_ATTACH_LIMIT}장까지만 첨부할 수 있습니다.`);
          }
        },
        children: /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(IconPlus, {
            size: 24,
            color: "var(--gray-10)"
          }), `${files.length}/${IMAGE_ATTACH_LIMIT}`]
        })
      }), files?.map((file, index) => {
        return /*#__PURE__*/_jsxs("div", {
          className: 'file-wrapper',
          children: [/*#__PURE__*/_jsx(Image, {
            alt: '',
            src: file.url,
            layout: "fill",
            objectFit: "cover"
          }), /*#__PURE__*/_jsx("button", {
            className: "delete-button",
            style: {
              zIndex: 5
            },
            onClick: () => {
              onDeleteFiles([file]);
            },
            children: /*#__PURE__*/_jsx(IconCircleXFilled, {
              size: 16,
              color: "var(--gray-10)"
            })
          })]
        }, index);
      })]
    }) : files?.length > 0 ? /*#__PURE__*/_jsx(PhotoProvider, {
      maskOpacity: 0.8,
      children: files?.map((file, index) => {
        return /*#__PURE__*/_jsx(PhotoView, {
          src: file.url,
          children: /*#__PURE__*/_jsx("div", {
            className: "file-wrapper",
            children: /*#__PURE__*/_jsx(Image, {
              alt: '',
              src: file.url,
              layout: "fill",
              objectFit: "cover"
            })
          })
        }, index);
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {})
  });
};
export default AttachImageFormV2;